/**
 * 获取用户收藏的包含指定资源的收藏夹列表。
 *
 * @param userId - 用户的 ID。
 * @param resourceId - 资源的 ID。
 * @param resourceType - 资源的类型。
 * @returns 返回用户收藏的包含指定资源的收藏夹列表的 Promise。
 *
 * @remarks
 * 该函数发送请求以获取用户收藏的包含指定资源的收藏夹列表。需要提供用户的 ID、资源的 ID 和资源的类型。
 * 只返回已收藏的收藏夹，并过滤掉未收藏的。
 * 请注意，如果发生请求失败，错误将不会在此处捕获，而是被传递给调用方处理。
 *
 * @example
 * ```typescript
 * const userCollectionsWithResource = await fetchCollectionByRes(123, 456, 1);
 * console.log(userCollectionsWithResource); // 返回用户收藏的包含指定资源的收藏夹列表
 * ```
 */
export async function fetchCollectionByRes(
  userId: number,
  resourceId?: number,
  resourceType?: number
): Promise<PostFavoriteFolder[]> {
  return http
    .get<{
      list: PostFavoriteFolder[]
    }>('/v1/favorite/get_favorite_list', {
      user_id: userId,
      resource_id: resourceId,
      resource_type: resourceType
    })
    .then((res) => res.data.list.filter((f) => f.is_favorite))
}
